// extracted by mini-css-extract-plugin
export default {"container":"EBH_lD","mobileContainer":"Kd8m34","divider":"ydvUcH"};